import {message, Modal} from "antd";
import {getSalesSheetHTML, getSpecSheetHTML, printStyle, SalesSheet, SpecSheet} from "./htmlTemplates";
import React, {useContext, useEffect, useRef, useState} from "react";
import {pick, now, delay, snakeCase} from "lodash";
import {downloadBlob} from "../Wizard/utils";
import {useReactToPrint} from "react-to-print";
import HtmlRender from "../services/htmlRender";
import QuarkRender from "../services/quarkRender";
import {ClientBridge} from "../index";
import {getAttachment} from "../lib/Utils";
//import OnImagesLoaded from 'react-on-images-loaded';


export default function ShareAction (
    {
        shareInfo, //subject , text ...
        shareAction,
        onShareDone = ()=>{}
    })
{
    const {mcc} = useContext(ClientBridge);

    const [htmlRender] = useState(() => new HtmlRender({
        baseURL: mcc.htmlToPdfServer
    }));
    const [quarkRender] = useState(() => new QuarkRender({
        baseURL: mcc.quarkRenderServer
    }));

    const busy = useRef(false);
    const printComponentRef = useRef();
    const printSpecSheet = useReactToPrint({
        content: () => printComponentRef.current,
        onAfterPrint: done,
        copyStyles: false,
        pageStyle: printStyle
    });
    const [printInfo, setPrintInfo] = useState({});
    const [printStatus, setPrintStatus] = useState('');

    const getImageUrl = (ad,maxSize) =>
        maxSize<=200 ? ad.thumbUrl
            : quarkRender.getConvertUrl({
                fileName:'any.jpg',
                url: ad.previewUrl,
                width:maxSize,
                height:maxSize,
                format:'jpg'
            });

    // todo ?still need busy
    useEffect(()=>{
            if (! busy.current && shareAction) {
                busy.current = true;
                processAction();
            }
        }
    , [shareAction]);

    function done(){
        setPrintStatus();
        busy.current = false;
        onShareDone();
    }


    //todo ?dodgy using Element like a function for email & download
    // - only print need to render an element
    // - ? revert to "Print from window approach - might need this for Android anyway)
    async function processAction() {
        switch (shareAction) {
            case 'Email':
                try {
                    await quarkRender.email(getEmailRequest(shareInfo));
                    message.info('Email sent');
                } catch (e) {
                    console.error(e);
                    message.error('Email failed');
                } finally {
                    done();
                }
                break;

            case 'PDF':
                try {
                    await downloadSpecSheet(shareInfo, htmlRender);
                } catch (e) {
                    console.error(e);
                    message.error('Spec sheet download failed');
                } finally {
                    done();
                }
                break;

            case 'Print':
                // todo
                //  Give AOD time to render ? just use preview we have
                //  can we detect failure?
                //  if not rendering this delay is not needed

                if (shareInfo.saveNeeded) {
                    delay(() => {
                        setPrintInfo(getHtmlInfo(shareInfo));
                        setPrintStatus('pending');
                    }, 2000);
                } else if (shareInfo.salesSheet) {
                    setPrintInfo(getSalesSheetHtmlInfo(shareInfo));
                    setPrintStatus('pending');
                } else {
                    setPrintInfo(getHtmlInfo(shareInfo));
                    setPrintStatus('pending');
                }
                break;
            default:
                console.error('Unsupported share action: ' + shareAction);
        }
    }

    const onTimeout = ()=>{
        if (printStatus === 'pending') {
            message.error('Print failed.');
        } else {
            console.warn('?None pending print timeout');
        }
        setPrintStatus('failed');
    }

    const onLoaded = ()=>{
        if (printStatus==='pending') {
            printSpecSheet();
            setPrintStatus('printing');
        }
    }



    const PrintSheet = shareInfo.salesSheet ? SalesSheet : SpecSheet;

    return <>
        {printStatus === 'pending' &&
            <div style={{display: "none"}}>
                <PrintSheet {...printInfo}
                            ref={printComponentRef}
                            onLoaded={onLoaded}
                            onTimeout={onTimeout}
                            getImageUrl={getImageUrl}
                />
            </div>}
            <Modal visible={printStatus === 'pending'}
                   onCancel={()=>setPrintStatus('cancelled')}
                   okText={'Loading...'} confirmLoading={true}
            >
                Loading spec ad previews...
            </Modal>
        </>
}
/*
return shareAction === 'Print' &&
        <div style={{display: "none"}}>
            <PrintSheet {...printInfo} ref={printComponentRef}/>
        </div>
 */



// Static functions moved outside body - no redfining...

async function downloadSpecSheet(shareInfo, htmlRender) {

    let html, fileName;

    // todo ? bump up this res
    const getImageUrl = (ad, maxSize) => {
        return maxSize<=200 ? ad.thumbUrl: ad.previewUrl;
    }

    // abstract...
    if (shareInfo.salesSheet){
        const htmlInfo = getSalesSheetHtmlInfo(shareInfo);
        html = getSalesSheetHTML({...htmlInfo, getImageUrl});
        fileName = snakeCase(shareInfo.salesSheet.name) + '_spec.pdf'; // sanitize or metroref
    }
    else {
        const htmlInfo = getHtmlInfo(shareInfo);
        html = getSpecSheetHTML({...htmlInfo, getImageUrl});
        fileName = htmlInfo.file_name + '_spec.pdf';  // jobNumber? ? metroRef
    }

    const blob = await htmlRender.render({html});
    await downloadBlob(blob, fileName);
}


function getHtmlInfo({specAd={}, formInfo={}, advertiser={}}={}){

    const {renderInfo, previewUrl, thumbUrl, metroReference, jobNumber} = specAd;
    //const renderInfo = JSON.parse(renderData);  //todo ? do this onload
    const {output, template} = renderInfo;

    // todo ? fromname  || owner || creator
    const {creator, subject, text} = formInfo;

    return {
        creator, subject, text,
        company: advertiser.company,
        file_name: template.file_base,
        asset: output,
        previewUrl,
        thumbUrl,
        metroReference,
        jobNumber
    };
}

function getSalesSheetHtmlInfo({ formInfo={}, advertiser={}, salesSheet}={}){

    const {name, metroReference, specAds, jobNumber} = salesSheet;  //?jobNumber
    const {creator, subject, text, columns} = formInfo;

    const ads = specAds.map(specAd=>{
        const {renderInfo, previewUrl, thumbUrl, metroReference, jobNumber} = specAd;
        //const renderInfo = JSON.parse(renderData);  //todo ? do this onload
        const {output, template} = renderInfo;

        return {
            file_name: template.file_base,
            asset: output,
            previewUrl,
            thumbUrl,
            metroReference,
            jobNumber
        };
    });

    return {
        creator, subject, text,
        company: advertiser.company,
        ads, columns,
        name, metroReference, jobNumber
    };
}


export function getEmailRequest(shareInfo) {

    const attachments = [];
    let html;
    const {formInfo, zipUrl} = shareInfo

    const addAttachment = (ad, maxSize) => {
        const attachment = getAttachment(maxSize<=200 ? ad.thumbUrl: ad.previewUrl,  ad.file_name);
        attachments.push(attachment);
        return 'cid:' + attachment.cid;
    }

    if (shareInfo.salesSheet){
        const htmlInfo = getSalesSheetHtmlInfo(shareInfo);
        html = getSalesSheetHTML({
            ...htmlInfo,
            getImageUrl: addAttachment
        });
    }
    else {
        const htmlInfo = getHtmlInfo(shareInfo);
        html = getSpecSheetHTML({
            ...htmlInfo,
            getImageUrl: addAttachment,
            zipUrl
        });
    }

    const request = {
        ...pick(formInfo, 'to', 'replyTo', 'subject', 'text'),
        from: {
            name: formInfo.fromName
        },
        html,
        attachments
    };
    if (formInfo.bccReplyTo) {
        request.bcc = formInfo.replyTo;
    }

    return request;
}